import merge from 'lodash.merge';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { BadRequestHttpError } from '~shared/modules/error-handler';
import {
  IAdvancedFormConfig, IAdvancedFormEvent, AdvancedFormEventTypes
} from '~shared/modules/advanced-form/models/advanced-form.model';
import { CREATE_ADDRESS_ACTION_LIST } from '../../constants/create-address.constant';
import { AddressBookService } from '../../services/address-book.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-create-address',
  templateUrl: './create-address.component.html',
})
export class CreateAddressComponent implements OnInit, OnDestroy {
  public advancedFormConfig: IAdvancedFormConfig;
  private destroy$ = new Subject<void>();

  constructor(
    private addressBookService: AddressBookService,
  ) {}

  public ngOnInit(): void {
    this.addressBookService.getAdvancedFormConfig().pipe(
      takeUntil(this.destroy$)
    ).subscribe((advancedFormConfig) => {
      this.advancedFormConfig = merge({}, advancedFormConfig, {
        actionList: CREATE_ADDRESS_ACTION_LIST,
      });
    });
  }

  public onAdvancedFormEvents(event: IAdvancedFormEvent): void {
    if (event.type === AdvancedFormEventTypes.submit) {
      const address = event.payload.formData; // as IAddress
      if (address.addressLine2 === null) {
        address.addressLine2 = '';
      }
      this.addressBookService.createAddress(address).pipe(
        take(1)
      ).subscribe(
        () => event.done(),
        (error: BadRequestHttpError) => event.done(error.invalidParams),
      );
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
